"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwalProvider = exports.SwalContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _sweetalert = _interopRequireDefault(require("sweetalert2"));
var _sweetalert2ReactContent = _interopRequireDefault(require("sweetalert2-react-content"));
var _ThemeProvider = _interopRequireDefault(require("@mui/material/styles/ThemeProvider.js"));
var _styledEngine = require("@mui/styled-engine");
var _useTheme = _interopRequireDefault(require("@mui/material/styles/useTheme.js"));
var _DefaultSwal = _interopRequireDefault(require("./DefaultSwal"));
var _styles = require("@mui/styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const RSwal = (0, _sweetalert2ReactContent.default)(_sweetalert.default);
const SwalContext = exports.SwalContext = /*#__PURE__*/_react.default.createContext(null);
const useStyles = (0, _styles.makeStyles)({
  container: {
    zIndex: 1500
  }
});
const SwalProvider = ({
  children,
  contentComponent: ProviderComp = _DefaultSwal.default
}) => {
  const theme = (0, _useTheme.default)();
  const classes = useStyles();
  const getContent = (Component, text, props = {}) => Component ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styledEngine.StyledEngineProvider, {
    injectFirst: true,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ThemeProvider.default, {
      theme: theme,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, {
        swal: RSwal,
        text: text,
        ...props
      })
    })
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styledEngine.StyledEngineProvider, {
    injectFirst: true,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ThemeProvider.default, {
      theme: theme,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ProviderComp, {
        swal: RSwal,
        text: text,
        ...props
      })
    })
  });
  const getDefaults = type => {
    switch (type) {
      case 'success':
        return {
          title: 'Success!',
          defaultText: 'It worked!'
        };
      case 'warning':
      case 'question':
        return {
          title: 'Are you sure?'
        };
      case 'error':
        return {
          title: 'Error.',
          defaultText: 'An error occurred.'
        };
      default:
        return {};
    }
  };
  const commonOptions = {
    heightAuto: false,
    showCancelButton: false,
    showConfirmButton: false,
    customClass: {
      container: classes.container
    }
  };
  const alert = (text, config = {}) => {
    const {
      confirmButtonProps,
      cancelButtonProps,
      component,
      type,
      ...swalProps
    } = config;
    const {
      defaultText,
      title
    } = getDefaults(type);
    return RSwal.fire({
      title,
      ...commonOptions,
      ...swalProps,
      icon: type,
      html: getContent(component, text || defaultText, {
        confirmButtonProps,
        cancelButtonProps
      })
    });
  };
  const confirm = (text, config = {}) => {
    const {
      confirmButtonProps,
      cancelButtonProps,
      component,
      type,
      showCancel = true,
      ...swalProps
    } = config;
    const {
      defaultText,
      title
    } = getDefaults(type);
    return RSwal.fire({
      title,
      showCloseButton: true,
      ...commonOptions,
      ...swalProps,
      icon: type,
      html: getContent(component, text || defaultText, {
        showCancel,
        confirmButtonProps,
        cancelButtonProps
      })
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(SwalContext.Provider, {
    value: {
      alert,
      confirm
    },
    children: children
  });
};
exports.SwalProvider = SwalProvider;